import { AuthProps, LoginData } from '@/@types/auth'
import { getCommonUrl } from '@/hooks/common/common-api-url'
import { getPrepareHeaders } from '@/hooks/common/common-functions'
import { VB_URL } from '@/config/env' // ✅ Import directly from config
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const vbAuthApi = createApi({
  reducerPath: 'vbAuth',
  baseQuery: fetchBaseQuery({
    baseUrl: VB_URL || 'https://core.venueboost.io/api/v1/', // ✅ Use centralized config
    prepareHeaders: (headers) => getPrepareHeaders({ headers }),
  }),
  tagTypes: ['vbUser'],
  endpoints: (builder) => ({
    checkConnection: builder.mutation<AuthProps, LoginData>({
      query: (body) => ({
        url: getCommonUrl({ queryString: '/vb-apps/verify-supabase' }),
        method: 'POST',
        body,
      }),
      invalidatesTags: ['vbUser'],
    }),
  }),
})

export const { useCheckConnectionMutation } = vbAuthApi